/**
 * Youtube TV On PC — reshapes YouTube into a TV-style layout
 *
 * Declares a single web-accessible resource, `injected-script.js`, with no
 * `use_dynamic_url` but scoped via `matches` to youtube.com only. The URL is fixed, so
 * it is a conclusive probe — but the resource is genuinely unreachable from any other
 * origin, so only YouTube can detect this extension.
 *
 * From anywhere else a negative proves nothing, hence `requiredOrigin`.
 *
 * Manifest verified against version 0.9.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'jldjbkccldgbegjpggphaeikombjmnkh';

export const youtubeTvOnPc: ExtensionDefinition = {
  id: ID,
  name: 'Youtube TV On PC',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 100_000,
  requiredOrigin: 'https://www.youtube.com',
  notes:
    'Its one WAR (injected-script.js) is scoped to youtube.com with no dynamic URL, so ' +
    'only that origin can detect it — conclusive there, silent everywhere else.',
  signals: [
    {
      id: 'war-injected-script-js',
      kind: 'web-accessible-resource',
      description:
        'Fetch injected-script.js — a fixed-URL resource, but only exposed to youtube.com.',
      weight: 1,
      run: () => probeFetch(ID, 'injected-script.js'),
    },
  ],
};
